import { Add, ArrowBack } from "@mui/icons-material";
import { Button, IconButton, Tooltip, Box } from "@mui/material";
import Pendo from "helpers/Pendo";
import { useState } from "react";
import { P } from "theme/typography";
import { useAppSelector } from "redux/hooks";
import { resendCollectInvite, selectPendingCollectUsers } from "redux/slices/client";
import { useNavigate } from "react-router";
import CollectInvite from "routes/users/collect/CollectInvite";
import CollectUsersInviteTable from "routes/users/collect/CollectUsersInviteTable";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { AppRoutes } from "AppRoutes";

function CollectInvites() {
  const [open, setOpen] = useState(false);
  const pendingUsers = useAppSelector(selectPendingCollectUsers);
  const snackpatch = useAppDispatchWithSnackbar();

  const resendInvite = (email: string) => {
    Pendo.event("invite_collect_user_resend", {});

    snackpatch(resendCollectInvite({ email }), {
      successMessage: `New Collect invite sent to ${email.toLowerCase()}`,
      errorMessage: `Unable to send an invitation to ${email.toLowerCase()}`,
    });
  };

  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}>
        <Box>
          <Tooltip title="Back to Collect users">
            <IconButton onClick={() => navigate(AppRoutes.collectUsers())}>
              <ArrowBack />
            </IconButton>
          </Tooltip>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <P variant="xl2Bold">Pending Collect Invites</P>
          <Button
            variant="contained"
            onClick={() => {
              setOpen(true);
            }}
            startIcon={<Add />}>
            Invite
          </Button>
        </Box>
        <CollectUsersInviteTable users={pendingUsers} resendInvite={resendInvite} />
      </Box>
      {open && <CollectInvite open={open} onClose={() => setOpen(false)} />}
    </>
  );
}

export default CollectInvites;
